import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgxGalleryModule } from 'ngx-gallery';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HomeSidebarComponent } from './components/home/home-sidebar/home-sidebar.component';
import { HomeWelcomeComponent } from './components/home/home-welcome/home-welcome.component';
import { HomeGalleryComponent } from './components/home/home-gallery/home-gallery.component';
import { HomeCommentsComponent } from './components/home/home-comments/home-comments.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavSigninComponent } from './components/navbar/nav-signin/nav-signin.component';
import { ProductsComponent } from './components/products/products.component';

//Routes
const appRoutes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'products', component: ProductsComponent}

]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomeSidebarComponent,
    HomeWelcomeComponent,
    HomeGalleryComponent,
    HomeCommentsComponent,
    NavbarComponent,
    FooterComponent,
    NavSigninComponent,
    ProductsComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    NgxGalleryModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts